export default {
    title: `Édito`,

    subTitleEN: `Bertrand Cozzarolo, directeur de Société Générale Private Banking`,
    subTitleMC: `Nicolas Feit, directeur de Société Générale Private Banking Monaco`,
    subTitleLU: `Olivier Lecler, directeur de Société Générale Private Banking Luxembourg`,
    subTitleCH: `Franck Bonin, directeur de Société Générale Private Banking Suisse`,
    subTitleFR: `Mathieu Vedrenne, directeur de Société Générale Private Banking France`,

    mainContent: `
    <p>
        Heïdi Sevestre, glaciologue accomplie et engagée, est l’invitée de cette édition.
    </p>
    <p>
        Elle nous emmène au plus près des glaciers pour comprendre les enjeux de la fonte des glaces. Puis, un scientifique et un expert de la gestion de l’eau partageront les stratégies adoptées par les pays insulaires ou côtiers, et notamment les Pays-Bas, afin de faire face à la montée du niveau de la mer.
    </p>
    <p>
        L’eau, véritable fil conducteur de ce numéro, vous conduira également à Venise, ville mythique qui a encore des secrets à livrer. Vous serez également invités à monter à bord du bateau-musée inauguré cette année par la fondation Art Explora. <br/>
        Il voguera durant deux ans en Méditerranée à la rencontre des publics d’une quinzaine de pays.
    </p>
    <p>
        Je vous souhaite une excellente lecture de ce magazine.
    </p>`,
};

